// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"658cede8","239":"49b42a40","455":"75e58717"}[chunkId] + ".chunk.js";
};